import { LIFECYCLE_STATE } from "~/assets/js/constants";
import { lifecycleToLifecycle } from "~/assets/js/logic/lifecycleToLifecycle";

export default {
  SET_VACCINES(state, vaccines) {
    state.vaccines = vaccines;
  },

  SET_VACCINE(state, updatedVaccine) {
    const index = state.vaccines.collection.findIndex(
      (vaccine) => vaccine.id === updatedVaccine.id,
    );
    if (index >= 0) {
      state.vaccines.collection.splice(index, 1, updatedVaccine);
    }
  },

  ADD_VACCINE(state, vaccine) {
    state.vaccines.collection.unshift(vaccine);
  },

  DELETE_VACCINE(state, id) {
    const index = state.vaccines.collection.findIndex((vaccine) => vaccine.id === id);
    if (index >= 0) {
      state.vaccines.collection.splice(index, 1);
    }
  },

  SET_VACCINE_LIST(state, vaccineList) {
    state.vaccineList = vaccineList;
  },

  SET_EDITING_VACCINE(state, editingVaccine) {
    state.editingVaccine = editingVaccine;
  },

  SET_VACCINE_STATUS_AUTORUN(state, { vaccineId, value }) {
    const index = state.vaccines.collection.findIndex((vaccine) => vaccine.id === vaccineId);
    if (index >= 0) {
      const updatedVaccine = state.vaccines.collection[index];
      updatedVaccine.autorun = value;
      state.vaccines.collection.splice(index, 1, updatedVaccine);
    }
  },

  SET_AGENCY_DEPLOYMENTS(state, { parent, agencyDeployments }) {
    this._vm.$set(state.agencyDeployments, parent, agencyDeployments);
  },

  REMOVE_AGENCY_DEPLOYMENTS(state, { parent }) {
    this._vm.$delete(state.agencyDeployments, parent);
  },

  REMOVE_ALL_AGENCY_DEPLOYMENTS(state) {
    for (const parent of Object.keys(state.agencyDeployments)) {
      this._vm.$delete(state.agencyDeployments, parent);
    }
  },

  SET_AGENT_DEPLOYMENTS(state, { parent, agentDeployments }) {
    this._vm.$set(state.agentDeployments, parent, agentDeployments);
  },

  REMOVE_AGENT_DEPLOYMENTS(state, { parent }) {
    this._vm.$delete(state.agentDeployments, parent);
  },

  REMOVE_ALL_AGENT_DEPLOYMENTS(state) {
    for (const parent of Object.keys(state.agentDeployments)) {
      this._vm.$delete(state.agentDeployments, parent);
    }
  },

  SET_AGENCY_DEPLOYMENT_STATUS(state, { agencyIds, vaccineId }) {
    const deploymentsCollection = state.agencyDeployments[vaccineId]?.collection;
    if (!deploymentsCollection) return;

    const index = deploymentsCollection.findIndex((deployment) => deployment.id === agencyIds[0]);
    if (index >= 0) {
      const deployment = deploymentsCollection[index];
      deployment.status = lifecycleToLifecycle(deployment.status);
      deploymentsCollection.splice(index, 1, deployment);
    }
  },

  SET_AGENT_DEPLOYMENT_STATUS(state, { agentIds, vaccineId }) {
    const deploymentsCollection = state.agentDeployments[vaccineId]?.collection;
    if (!deploymentsCollection) return;

    const index = deploymentsCollection.findIndex((deployment) => deployment.id === agentIds[0]);
    if (index >= 0) {
      const deployment = deploymentsCollection[index];
      deployment.status = lifecycleToLifecycle(deployment.status);
      deploymentsCollection.splice(index, 1, deployment);
    }
  },

  SET_AGENCY_DEPLOYMENT_STATUS_AUTORUN(state, { parent, value }) {
    if (state.agencyDeployments[parent]) {
      for (const deployment of state.agencyDeployments[parent].collection) {
        const newStatus = value
          ? LIFECYCLE_STATE.NOT_APPLIED_REQUIRED
          : LIFECYCLE_STATE.NOT_APPLIED_NOT_REQUIRED;
        this._vm.$set(deployment, "status", newStatus);
      }
    }
  },

  SET_AGENT_DEPLOYMENT_STATUS_AUTORUN(state, { parent, value }) {
    if (state.agentDeployments[parent]) {
      for (const deployment of state.agentDeployments[parent].collection) {
        const newStatus = value
          ? LIFECYCLE_STATE.NOT_APPLIED_REQUIRED
          : LIFECYCLE_STATE.NOT_APPLIED_NOT_REQUIRED;
        this._vm.$set(deployment, "status", newStatus);
      }
    }
  },

  SET_OSES(state, oses) {
    state.allOses = oses.collection;
  },

  SET_TYPES(state, types) {
    state.allTypes = types;
  },

  SET_CATEGORIES(state, categories) {
    state.allCategories = categories;
  },

  SET_FIELDS(state, fields) {
    state.dqlFields = fields;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
